import { useState } from "react";

interface ModalProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}

function ServiceModal({ title, onClose, children }: ModalProps) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center px-4"
      style={{ backgroundColor: "rgba(0,0,0,0.75)" }}
      onClick={onClose}
    >
      <div
        className="bg-[#111] border border-white/10 rounded-lg max-w-md w-full p-8 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-white/40 hover:text-white transition cursor-pointer"
        >
          <i className="ri-close-line text-xl"></i>
        </button>
        <h3 className="text-white text-sm tracking-widest uppercase font-medium mb-6">{title}</h3>
        {children}
      </div>
    </div>
  );
}

const services = [
  {
    icon: "ri-arrow-go-back-line",
    title: "Devoluções Gratuitas",
    desc: "Devoluções em até 7 dias após a compra",
    modal: "returns",
  },
  {
    icon: "ri-award-line",
    title: "Certificado",
    desc: "COMPROVE SEUS RESULTADOS E GANHE UM CERTIFICADO",
    modal: "gift",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Consultoria Individualizada",
    desc: "Agende uma sessão individual com nossas especialistas",
    modal: "stylist",
  },
];

export default function ServicesBar() {
  const [activeModal, setActiveModal] = useState<string | null>(null);

  return (
    <>
      <section className="py-16 px-6 md:px-16 bg-black">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-0 divide-y md:divide-y-0 md:divide-x divide-white/10">
          {services.map((s) => (
            <div
              key={s.title}
              onClick={() => setActiveModal(s.modal)}
              className="flex flex-col items-center text-center py-8 px-8 cursor-pointer group"
            >
              <div className="w-8 h-8 flex items-center justify-center mb-4">
                <i className={`${s.icon} text-2xl text-white/60 group-hover:text-[#b8962e] transition`}></i>
              </div>
              <h4 className="text-xs tracking-widest uppercase text-white font-medium mb-2 group-hover:text-[#b8962e] transition whitespace-nowrap">
                {s.title}
              </h4>
              <p className="text-white/50 text-xs leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {activeModal === "returns" && (
        <ServiceModal title="Política de Devoluções" onClose={() => setActiveModal(null)}>
          <div className="space-y-4 text-white/60 text-sm leading-relaxed">
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                <i className="ri-calendar-line text-[#b8962e]"></i>
              </div>
              <p><span className="text-white font-medium">7 dias</span> para solicitar a devolução após a data de recebimento do pedido.</p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                <i className="ri-bank-card-line text-[#b8962e]"></i>
              </div>
              <p>O reembolso é processado em até <span className="text-white font-medium">15 dias úteis</span> no mesmo método de pagamento.</p>
            </div>
            <div className="pt-4 border-t border-white/10">
              <p className="text-white/40 text-xs">Dúvidas? Entre em contato com nossa equipe pelo chat ou e-mail.</p>
            </div>
          </div>
        </ServiceModal>
      )}

      {activeModal === "gift" && (
        <ServiceModal title="Certificado" onClose={() => setActiveModal(null)}>
          <div className="space-y-4 text-white/60 text-sm leading-relaxed">
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                <i className="ri-award-line text-[#b8962e]"></i>
              </div>
              <p>ENVIE SEUS RESULTADOS E GANHE UM CERTIFICADO</p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                <i className="ri-price-tag-3-line text-[#b8962e]"></i>
              </div>
              <p>Disponível para todos os pedidos os cursos</p>
            </div>
          </div>
        </ServiceModal>
      )}

      {activeModal === "stylist" && (
        <ServiceModal title="Consultoria Individualizada" onClose={() => setActiveModal(null)}>
          <div className="space-y-4 text-white/60 text-sm leading-relaxed">
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                <i className="ri-user-star-line text-[#b8962e]"></i>
              </div>
              <p>Sessão individual com uma de nossas <span className="text-white font-medium">especialistas em moda</span>.</p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                <i className="ri-video-line text-[#b8962e]"></i>
              </div>
              <p>Atendimento <span className="text-white font-medium">presencial ou online</span> — escolha o formato que preferir.</p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                <i className="ri-time-line text-[#b8962e]"></i>
              </div>
              <p>Sessões de <span className="text-white font-medium">60 minutos</span></p>
            </div>
            <div className="pt-4 border-t border-white/10">
              <button
                onClick={() => setActiveModal(null)}
                className="w-full py-3 bg-[#b8962e] text-black text-xs tracking-widest uppercase font-medium rounded cursor-pointer hover:bg-[#d4aa40] transition whitespace-nowrap"
              >
                Agendar Sessão
              </button>
            </div>
          </div>
        </ServiceModal>
      )}
    </>
  );
}
